
import Briefcase from "../../../assets/outline/Briefcase.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BriefcaseIcon({ className, dataTestid = "BriefcaseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Briefcase data-testid={dataTestid} className={classes} {...rest} />
  );
}
